import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import Fade from '@material-ui/core/Fade';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  modal: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  paper: {
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const CustomModal = ({ isOpen, handleClose, children }) => {
  const styles = useStyles();

  return (
    <div>
      <Dialog
        maxWidth='sm'
        open={isOpen}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: '#2b2b2b',
          },
        }}
        className={styles.modal}
      >
        <Fade in={isOpen}>
          <div className={styles.paper}>{children}</div>
        </Fade>
      </Dialog>
    </div>
  );
};

CustomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default CustomModal;
